import numeral from 'numeral'

export default function getValueFromText(text) {
  if (!text) return null
  return numeral(text).value()
}
